<template>
  <v-card>
    <v-card-title class="bgcolor-6 modal">
      <h1 class="titleModal">{{literal["AGREGARECURSOS"]["TITULO"]}}</h1>
      <v-spacer></v-spacer>
      <i @click="closeModal()" class="icon-close"></i>
    </v-card-title>

    <v-card-text>
      <v-container fluid>
        <!--INICIO-->
        <template v-if="type == 'start' && !zoneDelete">
          <v-row style="font-weight:bold;font-size:15px">
            {{literal["AGREGARECURSOS"]["SUBTITULO"]}}
          </v-row>
          <br>
          <v-row>
            <v-col cols="12" sm="12" style="padding:0px">
              <v-btn @click.stop="createLink('web')" block elevation="0" class="btnAddResource">
                {{literal["AGREGARECURSOS"]["WEB"]}}
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" style="padding:0px">
              <v-btn @click.stop="createLink('page')" block elevation="0" class="btnAddResource">
                {{literal["AGREGARECURSOS"]["PAGINA"]}}
              </v-btn>
            </v-col>
            <v-col cols="12" sm="12" style="padding:0px">
              <v-btn @click.stop="createLink('resource')" block elevation="0" class="btnAddResource">
                {{literal["AGREGARECURSOS"]["RECURSO"]}}
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <!--CREAR ENLACE WEB-->
        <template v-else-if="type == 'web' || (zoneDelete && zoneDelete.tipo == 'linkWeb')">

          <!--ACTUALIZAR O ELIMINAR-->
          <template v-if="zoneDelete" >
            <v-row>
    
              <v-col cols="12" sm="12" style="padding:0px;font-size:15px;color:black">
                {{literal["AGREGARECURSOS"]["URL"]}}
              </v-col>
              
              <v-col cols="12" sm="12" style="padding:0px;">
                <v-text-field v-model="zoneDelete.url" style="padding:0px;"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" style="padding:0px;font-size:15px;color:black">
                {{literal["AGREGARECURSOS"]["NOMBRE"]}}
              </v-col>
              
              <v-col cols="12" sm="12" style="padding:0px;">
                <v-text-field maxlength="50" counter="50" v-model="zoneDelete.titulo" style="padding:0px;"></v-text-field>
              </v-col>
            </v-row>
            <div style="display:none">
              {{url = zoneDelete.url}}
              {{nameUrl = zoneDelete.titulo}}
            </div>
            <v-row justify="center">
              <v-col @click.stop="updateZone()" sm="6" style="padding:0px;text-align:center">
                <v-btn elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ACTUALIZAR"]}}
                </v-btn>
              </v-col>
              <v-col sm="6" style="padding:0px;text-align:center">
                <v-btn @click.stop="deleteZone()" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ELIMINAR"]}}
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <!--CREAR-->
          <template v-else>
              <v-row>
      
              <v-col cols="12" sm="12" style="padding:0px;font-size:15px;color:black">
                {{literal["AGREGARECURSOS"]["URL"]}}
              </v-col>
              
              <v-col cols="12" sm="12" style="padding:0px;">
                <v-text-field v-model="url" style="padding:0px;"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" style="padding:0px;font-size:15px;color:black">
                {{literal["AGREGARECURSOS"]["NOMBRE"]}}
              </v-col>
              
              <v-col cols="12" sm="12" style="padding:0px;">
                <v-text-field maxlength="50" counter="50" v-model="nameUrl" style="padding:0px;"></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col @click.stop="addLinkWeb('start')" sm="6" style="padding:0px;text-align:center">
                <v-btn elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ACEPTAR"]}}
                </v-btn>
              </v-col>
              <v-col sm="6" style="padding:0px;text-align:center">
                <v-btn @click.stop="createLink('start')" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["CANCELAR"]}}
                </v-btn>
              </v-col>
            </v-row>
          </template>
          
        </template>

        <!--CREAR ENLACE A UNA PAGINA-->
        <template v-else-if="type == 'page' || (zoneDelete && zoneDelete.tipo == 'linkPage')">
          <v-row>
            <v-col class="d-flex input" cols="12" sm="4">
              <v-select @input="getValue" v-model="component" :return-object="true" :label="literal['RECURSOS']['COMPONENTE']" :items="showUnit"></v-select>
            </v-col>
            <v-col sm="12">
              <section style="overflow: auto;white-space:nowrap">

                <!--PRIMER ELEMENTO-->
                <a class="thumbnail" >
                  <img @click.stop="selectPage($event, 0)" :class="{'current':true, 'select': (zoneDelete && zoneDelete.lm == indexComponent && zoneDelete.page == 0)}" :src="rutaImg(0)" />
                  <span>{{$store.state.ebook[indexComponent].paginas[0]}}</span>
                </a>

                <!--ELEMENTOS INTERMEDIOS-->
                <template v-for="(page, index) in $store.state.ebook[indexComponent].paginas" >
                    <a class="thumbnail" :key="index" v-if="index != 0 && index % 2 == 0">
                      <img @click.stop="selectPage($event, index - 1)"  :class="{'current': true, 'select': (zoneDelete && zoneDelete.lm == indexComponent && zoneDelete.page == index - 1)}" :src="rutaImg(index - 1)" />
                      <img @click.stop="selectPage($event, index)" :class="{'current':true, 'select': (zoneDelete && zoneDelete.lm == indexComponent && zoneDelete.page == index)}" :src="rutaImg(index)" />
                      <span>{{$store.state.ebook[indexComponent].paginas[index - 1]}} - {{$store.state.ebook[indexComponent].paginas[index]}}</span>
                    </a>
                </template>

                <!--ULTIMO ELEMENTO-->
                <a class="thumbnail" >
                  <img @click.stop="selectPage($event, $store.state.ebook[indexComponent].paginas.length - 1)" :class="{'current':true,'select': (zoneDelete && zoneDelete.lm == indexComponent && zoneDelete.page == $store.state.ebook[indexComponent].paginas.length - 1)}" :src="rutaImg($store.state.ebook[indexComponent].paginas.length - 1)" />
                  <span>{{$store.state.ebook[indexComponent].paginas[$store.state.ebook[indexComponent].paginas.length - 1]}}</span>
                </a>
              </section>
            </v-col>
          </v-row>
          <template v-if="zoneDelete">
            <v-row :justify="'center'">
              <v-col sm="2" lg="1" offset-sm="8" offset-lg="10" style="padding:0px;text-align:center">
                <v-btn @click.stop="updateZone()" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ACTUALIZAR"]}}
                </v-btn>
              </v-col>
              <v-col sm="2" lg="1" style="padding:0px;text-align:center">
                <v-btn @click.stop="deleteZone()" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ELIMINAR"]}}
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row :justify="'center'">
              <v-col sm="2" lg="1" offset-sm="8" offset-lg="10" style="padding:0px;text-align:center">
                <v-btn @click.stop="addLinkPage()" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["ACEPTAR"]}}
                </v-btn>
              </v-col>
              <v-col sm="2" lg="1" style="padding:0px;text-align:center">
                <v-btn @click.stop="createLink('start')" elevation="1" class="btnAddResource">
                  {{literal["AGREGARECURSOS"]["CANCELAR"]}}
                </v-btn>
              </v-col>
            </v-row>
          </template>
          
        </template>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import $ from 'jquery'
import { mapState, mapMutations } from "vuex";

export default {
  name: "ModalAddResource",

  data: () => ({
    type: "start",
    url: "http://",
    nameUrl: "",
    component: null,
    indexComponent: 0,
    index: null
  }),
  props:['literal'],
  methods: {
    createLink(type){
      switch(type){
        case "start":
          this.setWidthModal(370)
          break;
        case "page":
          let temp = document.getElementsByClassName("current")
          temp.forEach((item, i)=>{
            item.style['border-color'] = 'white'
          })
          this.component = { text: this.$store.state.ebook[this.indexComponent].nombre, value: 0 }
          this.setWidthModal(1440)
          break;
        case "resource":
          this.setModalAddResource(false)
          this.setModalResource(true)
          this.setTypeModalResource("typeResourceEdit")
          // modalResource.style.backgroundColor = '#FF00FF';
          return;
      }
      this.type = type;
    },
    getValue(e){
      this.indexComponent = e.value
    },
    closeModal(){
      this.$store.state.isModeActiveZone = false;
      this.setModalAddResource(false);
      this.setZoneDelete(null);
      var pageImg = document.getElementsByClassName("zonaTransparente");
      pageImg[0].hidden = true;
      pageImg[1].hidden = true;
    },
    deleteZone(){
      this.deleteZoneActive(this.zoneDelete.id);
      this.setModalAddResource(false);
    },
    updateZone(){
      if(this.zoneDelete.tipo == "linkPage"){
        let nameLM = this.$store.state.ebook[this.indexComponent].nombre; //Carpeta donde se aloja las paginas del LM
        this.zoneDelete.lm = this.indexComponent;
        this.zoneDelete.page = this.index;
        this.zoneDelete.titulo = this.literal["AGREGARECURSOS"]["IRPAGE1"] + this.$store.state.ebook[this.indexComponent]["paginas"][this.index] + this.literal["AGREGARECURSOS"]["IRPAGE2"] + nameLM;
      } 
      
      this.updateZoneActive(this.zoneDelete.id);
      this.setModalAddResource(false);
    },
    addLinkWeb(){
      this.zoneTemp.data.url = this.url;
      this.zoneTemp.data.titulo = this.nameUrl;
      this.zoneTemp.data.tipo = "linkWeb";
      let payload = {page: this.zoneTemp.page, data: this.zoneTemp.data};
      this.addZoneActive(payload);
      this.setModalAddResource(false)
    },
    addLinkPage(){
      let payload = {page: this.zoneTemp.page, data: this.zoneTemp.data};
      let nameLM = this.$store.state.ebook[this.indexComponent].nombre; //Carpeta donde se aloja las paginas del LM
      this.zoneTemp.data.lm = this.indexComponent;
      this.zoneTemp.data.page = this.index;
      this.zoneTemp.data.tipo = "linkPage";
      this.zoneTemp.data.titulo = this.literal["AGREGARECURSOS"]["IRPAGE1"] + this.$store.state.ebook[this.indexComponent]["paginas"][this.index] + this.literal["AGREGARECURSOS"]["IRPAGE2"] + nameLM;
      this.addZoneActive(payload);
      this.setModalAddResource(false)
    },
    selectPage(e, index){
      let temp = document.getElementsByClassName("current")
      temp.forEach((item, i)=>{
        
        if(i == index) {
          item.style['border-color'] = '#F2942C'
        } else {
          item.style['border-color'] = 'white'
        }
      })
      this.index = index
      
    },
    rutaImg(img){
      if(img != null){
        try{
          let carpetaLM = this.$store.state.ebook[this.indexComponent].carpeta; //Carpeta donde se aloja las paginas del LM
          let existeImg = require("@/assets/img/paginas/" + carpetaLM +"/" + (img + 1) + ".jpg");
          return existeImg;
        } catch {
          return ''
        }
      } 
      return '';
    },
    ...mapMutations(['updateZoneActive','deleteZoneActive','setModalAddResource', "setModalResource", "setTypeModalResource", "setWidthModal", "addZoneActive", "setZoneDelete"])
  },
  mounted: function(){
      // this.selectLM = this.$store.state.ebook[this.indexLM].nombre;
  },
  computed:{
    showUnit(){
      let ebook = this.$store.state.ebook
      let itemsUnit = [];
      
      ebook.forEach((element, index) => {

        itemsUnit.push({value: index, text: element.nombre})
      });
      
      return itemsUnit; 
    },
    ...mapState(['zoneTemp', "zoneDelete"])
  }
};
</script>

<style>
  .btnAddResource{
    text-transform: none !important;
    color: black !important;
  }
  .btnAddResource:hover{
    color: #F2942C !important;
  }
  .thumbnail img:hover{
    border-color: #F2942E;
  }

  .thumbnail img:active{
    border-color: #F2942C !important;
  }

  /* .thumbnail span:hover{
    color: #F2942E !important;
  } */
</style>


